import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Customer, CustomerAddress, CustomerContact } from '@app/modules/customer/models';
import { AppState } from '@app/reducers';
import {
  AgentLoginService,
  DATE_FORMAT_TYPES,
  LoggedInUserModel,
  agentLoginDataSelector,
  prepareDynamicTableTabsFromPermissions,
  sidebarDataSelector$,
  OtherService
} from '@app/shared';
import { ModuleName } from '@app/shared/enums';
import { RxjsService } from '@app/shared/services';
import { IApplicationResponse } from '@app/shared/utils/interfaces.utils';
import { FEATURE_NAME } from '@modules/customer/components/non-customer-profile/shared/enum/index.enum';
import { EmailCompType } from '@modules/my-tasks/components/email-dashboard/email-comp-type.enum';
import { loggedInUserData } from '@modules/others';
import { Store, select } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { filter } from 'rxjs/operators';
import { PrimeNgTableVariablesModel } from '../../../../../../shared/models/prime-ng-table-list-component-variables.model';
import { CustomerManagementService } from '../../../../services/customermanagement.services';
import { convertKebabToTitleCase } from '@app/shared/utils/functions.utils';

@Component({
  selector: 'app-customer-add-edit',
  templateUrl: './customer-add-edit.component.html',
  styleUrls: ['./customer-add-edit.component.scss']
})

export class CustomerAddEditComponent extends PrimeNgTableVariablesModel implements OnInit {
  applicationResponse: IApplicationResponse;
  customer = {};
  customerAddress: CustomerAddress[];
  customerContact: CustomerContact[];
  selection = new SelectionModel<Customer>(true, []);
  dataSource = new MatTableDataSource<Customer>();
  custList = [];
  isRelocated = false;
  contactUpdate = false;
  custInfoList;
  partitionId = "";
  inputParams = { fromComponentUrl: 'customer', customerId: "", addressId: "" };
  relocationIndex;
  isLoading = true;
  isDealer: boolean = false;
  isProfileActivated: boolean = false;
  customerAddresses = [];
  addressId = "";
  idsObject;
  selectedAddressDetails;
  otherParams;
  selectedAddressIndex = 0;
  customerId;
  uniqueCallId;
  emailComptype: string = EmailCompType.CUSTOMER;
  feature = "";
  featureIndex: number;
  agentExtensionNo: string;
  isEnableProfileInformation = false
  customerProfile: any;
  isDisableQuickServiceCall = false;
  primengTableConfigPropertiesObj: any = {
    tableComponentConfigs: {
      tabsList: [
        {
          caption: "RECENT ACTIVITIES",
          url: '',
          disabled: true,
        },
        {
          caption: "AUDIT HISTORY OF CUSTOMER",
          url: 'audit-history-customer',
          disabled: true,
        },
        {
          caption: "SALES",
          url: 'sales',
          disabled: true,
        },
        {
          caption: "TECHNICAL",
          url: 'technical',
          disabled: true,
        },
        {
          caption: "MONITORING & RESPONSE",
          url: 'monitoring-response',
          disabled: true,
        },
        {
          caption: "SUPPORT DOCUMENT",
          url: 'support-document',
          disabled: true,
        },
        {
          caption: "SUBSCRIPTION",
          url: 'subscription',
          disabled: true,
        },
        {
          caption: "SITE ADDRESS INFO",
          url: 'site-address-info',
          disabled: true,
        },
        {
          caption: "TICKETING",
          url: 'ticketing',
          disabled: true,
        },
        {
          caption: "TRANSACTIONS",
          url: 'transactions',
          disabled: true,
        },
        {
          caption: "DEBTOR INFO",
          url: 'debtor-info',
          disabled: true,
        },
        {
          caption: "CLASSIFICATIONS",
          url: 'classifications',
          disabled: true,
        },
        {
          caption: "PROFILE INFORMATION",
          url: 'profile-information',
          disabled: true,
        },
        {
          caption: "INFO",
          url: 'info',
          disabled: true,
        },
        {
          caption: "CALL HISTORY",
          url: 'call-history',
          disabled: true,
        },
        {
          caption: "EMAILS",
          url: 'emails',
          disabled: true,
        },
        {
          caption: "CORRESPONDENCE LOG",
          url: 'correspondence-log',
          disabled: true,
        },
      ]
    }
  }
  DATE_FORMAT_TYPES = DATE_FORMAT_TYPES;
  contactUpdateSubscription: any;
  customerAddEditSubscription: any;
  customerQuerySubscription: any;
  customerObjchckes = {}
  private currentTitle: string = '';
  private titleUpdateTimeout: any;
  private titleUpdateInterval: any;
  
  constructor(private customerManagementService: CustomerManagementService, private dialog: MatDialog,
    private activatedRoute: ActivatedRoute, private router: Router, private store: Store<AppState>, private rxjsService: RxjsService,
    private agentLoginService: AgentLoginService, private otherService: OtherService, private title: Title) {
    super();
    this.store.pipe(select(loggedInUserData)).subscribe((loggedInUserModel: LoggedInUserModel) => {
      if (!loggedInUserModel) return;
      this.loggedInUserData = loggedInUserModel;
    });
    if (this.customerQuerySubscription && !this.customerQuerySubscription?.closed) {
      this.customerQuerySubscription?.unsubscribe();
    }
    this.customerQuerySubscription = this.activatedRoute.queryParams.subscribe((query) => {
      this.customerId = query['customerId'];
      // if (!this.customerObjchckes[`${query.customerId}-${query.navigateTab}-${query.monitoringTab}`]) {
      if (this.customerId) {
        this.getCustomerInfo(this.customerId);
        this.customerObjchckes[`${query.customerId}-${query.navigateTab}-${query.monitoringTab}`] = query.customerId;
      }
      setTimeout(() => {
        this.rxjsService.setGlobalLoaderProperty(false);
      }, 500);
      // }
      
      // Update title when query parameters change
      this.updatePageTitle();
    })
    this.customer['customerId'] = this.customerId;
    this.rxjsService.setCustomerDate(this.customer);
    this.onAfterQueryParamChange(this.activatedRoute.snapshot.queryParams);
    this.combineLatestNgrxStoreDataOne();

    this.rxjsService.getUniqueCallId().subscribe((openscapeConfigDetail) => {
      if (openscapeConfigDetail) {
        this.uniqueCallId = openscapeConfigDetail.UniqueCallid;
      }
    });
    this.rxjsService.setToggleQuickActionComponent(null);
  }

  getCustomerNameWithBrackets(name) {
    return name?.toString()?.indexOf('<br>') != -1;
  }

  getAfterAddressData() {
    if (this.contactUpdateSubscription && !this.contactUpdateSubscription?.closed) {
      this.contactUpdateSubscription?.unsubscribe();
    }
    this.contactUpdateSubscription = this.rxjsService.getContactUpdateDetails().subscribe((contact: boolean) => {
      this.contactUpdate = contact;
      if (this.contactUpdate) {
        this.rxjsService.setContactUpdateDetails(false)
        this.getCustomerInfo(this.customerId);
      }
    });
    this.rxjsService.getRelocation().subscribe((isRelocated: boolean) => {
      this.isRelocated = isRelocated;
    });
  }

  ngOnInit(): void {
    this.store.pipe(select(agentLoginDataSelector)).subscribe((extension: string) => {
      this.agentExtensionNo = extension;
    });
    this.relocationIndex = this.activatedRoute.snapshot.queryParams.index;
    this.rxjsService.getGlobalLoaderProperty().subscribe((isLoading: boolean) => {
      this.isLoading = isLoading;
    });
    this.getAfterAddressData();
    this.customerAddEditSubscription = this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((data: any) => {
      if (data?.url?.indexOf('manage-customers/view') > -1 && !this.isRelocated) {
        this.onSequenceChangeEvent({ index: +this.activatedRoute.snapshot?.queryParams?.navigateTab });
      }
    })
    //for on load the page
    this.activatedRoute.url.subscribe((data: any) => {
      if (data?.url?.indexOf('manage-customers/view') > -1) {
        this.onSequenceChangeEvent({ index: +this.activatedRoute.snapshot?.queryParams?.navigateTab });
      }
    })
    this.rxjsService.setToggleQuickActionComponent(null);
    
    // Update title on component initialization
    setTimeout(() => {
      this.updatePageTitle();
    }, 200);
  }

  combineLatestNgrxStoreDataOne() {
    combineLatest([
      this.store.select(sidebarDataSelector$),
    ])
      .subscribe((response: any) => {
        let customerManagemnt = response[0]?.['menuAccess'].find(item => item.menuName == "Customer Management");
        if (!customerManagemnt) return "";
        let customers = customerManagemnt['subMenu']?.find(item => item.menuName == "Customers");
        let permissions = customers?.subMenu
        if (permissions) {
          let customerManagement = permissions?.find(item => item.menuName == "Customer Dashboard")
          if (customerManagement) {
            let prepareDynamicTableTabsFromPermissionsObj = prepareDynamicTableTabsFromPermissions(this.primengTableConfigPropertiesObj, customerManagement['subMenu']);
            this.primengTableConfigPropertiesObj = prepareDynamicTableTabsFromPermissionsObj['primengTableConfigProperties'];
            customerManagement['subMenu']?.forEach((item, index) => {
              this.primengTableConfigPropertiesObj.tableComponentConfigs.tabsList[+item.sortOrder - 1]['actions'] = item
            })
            if (!this.isEnableProfileInformation || this.primengTableConfigPropertiesObj.tableComponentConfigs.tabsList[12]?.disabled) {
              this.primengTableConfigPropertiesObj.tableComponentConfigs.tabsList[12].disabled = true;
            }
            this.primengTableConfigPropertiesObj.tableComponentConfigs.tabsList[0].disabled = false;
            this.primengTableConfigPropertiesObj.tableComponentConfigs.tabsList[4].disabled = false;
          }
        }
      });
  }

  ngAfterViewInit() {
  }

  changeAddress(type = 'default') {
    // if (!this.addressId) {
    //   return;
    // }
    if (type == 'changeAddress') {
      this.onAfterChangeAddress();
      this.getCustomerInfo(this.customerId)
    }
  }

  onAfterChangeAddress() {
    if (this.addressId) {
      this.selectedAddressDetails = this.customerAddresses?.find(cA => cA['addressId'] == this.addressId);
      this.custInfoList["addressSiteType"] = this.selectedAddressDetails?.siteTypeName;
      if (this.selectedAddressDetails?.partitionDetails?.length > 0) {
        this.partitionId = this.selectedAddressDetails?.partitionDetails?.find(pD => pD['id'] == this.partitionId) ? this.partitionId :
          this.selectedAddressDetails?.partitionDetails?.find(pD => pD['isPrimary']) ? this.selectedAddressDetails?.partitionDetails?.find(pD => pD['isPrimary']).id :
            this.selectedAddressDetails?.partitionDetails[0]?.id;
        this.rxjsService.setCustomerPartitionId(this.partitionId ? this.partitionId : null);
      } else {
        this.partitionId = "";
        this.rxjsService.setCustomerPartitionId(null);
      }
      this.selectedAddressIndex = this.customerAddresses?.findIndex(cA => cA['addressId'] == this.addressId);
      this.idsObject = JSON.stringify({ addressId: this.addressId, customerId: this.custInfoList?.customerId });
      this.rxjsService.setCustomerAddresId(this.addressId);
      if (!this.isRelocated) {
        this.navigateViewCustomerWithoutReload();
      }
      this.custInfoList.siteId = this.selectedAddressDetails?.siteId;
      this.custInfoList.createdDate = this.selectedAddressDetails?.createdDate;
    }
    this.rxjsService.setCustomerInfo(this.custInfoList);
    this.rxjsService.setSelectedAddressInfo(this.selectedAddressDetails);
  }

  onChangePartition(event) {
    this.rxjsService.setCustomerPartitionId(event);
    if (!this.isRelocated) {
      this.navigateViewCustomerWithoutReload();
    }
    setTimeout(() => {
      this.rxjsService.setGlobalLoaderProperty(false);
    }, 500);

  }

  onAfterQueryParamChange(response) {
    if (Object.keys(response).length) {
      this.addressId = response?.addressId ? response?.addressId?.toLowerCase() : '';
      this.selectedTabIndex = response?.navigateTab?.toString() ? +response?.navigateTab : 0;
      this.feature = response?.feature_name ? response?.feature_name : '';
      this.featureIndex = response?.featureIndex?.toString() ? +response?.featureIndex : 0;
      if (this.feature == FEATURE_NAME.CAMERA_PROFILE || this.feature == FEATURE_NAME.COMMUNITY_PROFILE || this.feature == FEATURE_NAME.HUB_PROFILE || this.feature == FEATURE_NAME.EXECU_GUARD_PROFILE || this.feature == FEATURE_NAME.REPEATER_PROFILE) {
        this.isEnableProfileInformation = true;
      }
      this.updatePageTitle();
    }
  }
  //===========CUSTOMER INFO============//x
  getCustomerInfo(custId) {
    if (!custId) {
      return;
    }
    this.customerManagementService.getCustomer(custId).subscribe(resp => {
      if (resp?.isSuccess && resp?.statusCode == 200) {
        this.rxjsService.setGlobalLoaderProperty(false);
        this.customerAddresses = resp.resources?.addresses;
        if (this.activatedRoute?.snapshot?.queryParams?.addressId) {
          this.addressId = this.activatedRoute?.snapshot?.queryParams?.addressId?.toLowerCase();
        } else {
          this.addressId = resp?.resources?.addresses?.length > 0 ? resp?.resources?.addresses[0]?.addressId : null;
        }
        this.selectedAddressDetails = this.customerAddresses?.find(cA => cA['addressId'] == this.addressId);
        this.applicationResponse = resp;
        // this.isDisableQuickServiceCall = resp?.resources?.isCounterSale;
        this.customer = this.applicationResponse?.resources;
        this.custList = this.applicationResponse?.resources;
        this.onSetProfileData(resp);
        let customerData = {
          customerId: this.customer['customerId'],
          customerRefNo: this.customer['customerRefNo'],
          contactPerson: this.customer['customerName'],
          contactNumber: this.customer['mobileNumber1'],
          status: this.customer['status'],
          firstName: this.customer['firstName'],
          lastName: this.customer['lastName'],
          titleId: this.customer['titleId'],
        }
        this.rxjsService.setCustomerDate(customerData);
        this.custInfoList = this.applicationResponse?.resources;
        this.custInfoList["addressSiteType"] = this.selectedAddressDetails?.siteTypeName
        this.customerProfile = this.custInfoList?.customerProfileTypeName
        this.rxjsService.setCustomerProfile(this.customerProfile)
        this.idsObject = JSON.stringify({ addressId: this.addressId, customerId: resp.resources.customerId });
        // if (this.custInfoList?.status != 'Active') {
        //   this.primengTableConfigPropertiesObj.tableComponentConfigs.tabsList[7].disabled = true;
        // } else {
        //   this.primengTableConfigPropertiesObj.tableComponentConfigs.tabsList[7].disabled = false;
        // }
        this.onAfterChangeAddress();
      }
      this.rxjsService.setGlobalLoaderProperty(false);
    });
  }

  redirectToCustomerViewPage(e) {
    this.selectedTabIndex = e.navigateTab;
    setTimeout(() => {
      // Get the current query parameters to preserve fromComponent
      const currentQueryParams = this.activatedRoute.snapshot.queryParams;
      
      this.rxjsService.setViewCustomerData({
        customerId: this.customerId, 
        addressId: this.addressId, 
        partitionId: this.partitionId,
        customerTab: e.navigateTab,
        monitoringTab: e.monitoringTab,
        feature_name: this.feature, 
        featureIndex: this.featureIndex,
        fromComponent: currentQueryParams['fromComponent'] // Preserve the fromComponent parameter
      })
      this.rxjsService.navigateToViewCustomerPage();
    }, 500)
  }

  onSetProfileData(resp) {
    let customerList;
    customerList = resp.resources;
    if (customerList?.isProfileActivated)
      this.isProfileActivated = customerList.isProfileActivated ? true : false;
    if (customerList?.customerProfileTypeName == 'Dealers Profile') {
      this.isDealer = true;
    }
  }

  navigateViewCustomerWithoutReload() {
    let queryParams = { addressId: this.addressId, partitionId: this.partitionId, };
    if (this.partitionId) {
      queryParams['partitionId'] = this.partitionId;
    }
    if (this.feature && this.featureIndex) {
      queryParams['feature_name'] = this.feature;
      queryParams['featureIndex'] = this.featureIndex;
    }
    const url = this.router.url?.indexOf('manage-customers/view') != -1;
    if (url) {
      this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: queryParams,
        queryParamsHandling: 'merge',
        skipLocationChange: false
      });
    }
  }

  onSequenceChangeEvent(event) {
    this.selectedTabIndex = +event.index;
    this.navigateViewCustomerWithoutReload();
  }

  tabClick(e) {
    this.selectedTabIndex = +e?.index;
    
    // Get the current query parameters to preserve fromComponent
    const currentQueryParams = this.activatedRoute.snapshot.queryParams;
    
    this.rxjsService.setViewCustomerData({
      customerId: this.customerId, 
      addressId: this.addressId, 
      partitionId: this.partitionId, 
      customerTab: this.selectedTabIndex, 
      monitoringTab: this.selectedTabIndex == 4 ? +this.activatedRoute.snapshot?.queryParams?.monitoringTab : 0,
      feature_name: this.feature, 
      featureIndex: this.featureIndex,
      fromComponent: currentQueryParams['fromComponent'] // Preserve the fromComponent parameter
    });
    this.rxjsService.navigateToViewCustomerPage();
  }

  openQuickAction() {
    this.rxjsService.setQuickActionComponent(ModuleName.CUSTOMER);
    this.rxjsService.setToggleQuickActionComponent(true);
  }

  callDial(e, debtorInfo: any = {}): void {
    if (!this.agentExtensionNo) {
      this.agentLoginService.openOpenscapeLoginPopup();
    } else {
      let data = {
        customerContactNumber: debtorInfo?.contactNumber ? debtorInfo.contactNumber : e,
        customerId: this.customerId,
        clientName: debtorInfo?.debtorName ? debtorInfo.debtorName : this.custInfoList?.customerName,
        siteAddressId: this.addressId
      }
      this.agentLoginService.setCustomerDataAndExpandOpenscapeDialpad(data);
    }
  }

  formatFeatureName(featureName: string): string {
    return convertKebabToTitleCase(featureName);
  }

  updatePageTitle(): void {
    // Clear any existing timeout and interval
    if (this.titleUpdateTimeout) {
      clearTimeout(this.titleUpdateTimeout);
    }
    if (this.titleUpdateInterval) {
      clearInterval(this.titleUpdateInterval);
    }

    // Set title immediately without delay
    const fromComponent = this.activatedRoute.snapshot.queryParams.fromComponent;
    const featureName = this.activatedRoute.snapshot.queryParams.feature_name;
    
    console.log('updatePageTitle - fromComponent:', fromComponent, 'featureName:', featureName);
    
    let newTitle = 'Customer View';
    
    if (fromComponent === 'Non Customers' || featureName) {
      // It's a non-customer profile
      if (featureName) {
        newTitle = `${this.formatFeatureName(featureName)} View`;
      } else {
        newTitle = 'Non Customer View';
      }
    } else {
      // It's a regular customer
      newTitle = 'Customer View';
    }
    
    console.log('updatePageTitle - newTitle:', newTitle, 'currentTitle:', this.currentTitle);
    
    // Only update the title if it's different from the current title
    if (newTitle !== this.currentTitle) {
      this.currentTitle = newTitle;
      
      // Set the custom title in OtherService - this will prevent app component from overriding
      this.otherService.customTitle = newTitle;
      console.log('updatePageTitle - Custom title set to:', newTitle);
      
      // Also set the browser title directly to ensure it's set immediately
      this.title.setTitle(newTitle + ' - Fidelity');
      console.log('updatePageTitle - Browser title set to:', newTitle + ' - Fidelity');
      
      // Set up a very frequent interval to continuously set the title to prevent app component from overriding
      this.titleUpdateInterval = setInterval(() => {
        this.title.setTitle(newTitle + ' - Fidelity');
      }, 100); // Set title every 100ms for very aggressive protection
      
      // Stop the interval after 20 seconds
      setTimeout(() => {
        if (this.titleUpdateInterval) {
          clearInterval(this.titleUpdateInterval);
          this.titleUpdateInterval = null;
          console.log('updatePageTitle - Interval stopped');
        }
      }, 20000);
    }
  }

  ngOnDestroy() {
    if (this.customerAddEditSubscription) {
      this.customerAddEditSubscription?.unsubscribe();
    }
    if (this.contactUpdateSubscription) {
      this.contactUpdateSubscription?.unsubscribe();
    }
    if (this.customerQuerySubscription) {
      this.customerQuerySubscription?.unsubscribe();
    }
    // Clear any pending title update timeout and interval
    if (this.titleUpdateInterval) {
      clearInterval(this.titleUpdateInterval);
    }
    // Clear the custom title when component is destroyed
    this.otherService.customTitle = null;
    this.rxjsService.setToggleQuickActionComponent(null);
  }
}
